import { SocketIOClientSocket } from 'socket.io-client';

import { actionTypes } from './constants';
import * as Types from './types';

export const setConnectionAction = (connection: SocketIOClientSocket): Types.ISetConnectionAction => ({
    type: actionTypes.SET_CONNECTION,
    payload: connection
});

export const unsetConnectionAction = (): Types.IUnsetConnectionAction => ({
    type: actionTypes.UNSET_CONNECTION
});

export const setConnectedAction = (connected: boolean): Types.ISetConnectedAction => ({
    type: actionTypes.SET_CONNECTED,
    payload: connected
});

export const toggleConnectionErrorAction = (isError: boolean): Types.IToggleConnectionErrorAction => ({
    type: actionTypes.TOGGLE_CONNECTION_ERROR,
    payload: isError
});
